import { Link, Stack, Typography } from '@mui/material';
import { Button } from 'system/atoms';
import { TextBlock } from 'common/ui/TextBlock';
import { useDrawer } from 'services/drawer/hooks';

export const WhatsAppLearnMoreDrawer: React.FC<{
  organizationName: string;
}> = ({ organizationName }) => {
  const { closeDrawer } = useDrawer();

  return (
    <Stack width="500px" gap="40px" pb="20px">
      <TextBlock variant="drawer" title="Using WhatsApp" />
      <Typography variant="subtitle1">
        Make sure candidates you contact are relevant for your campaign if you
        wish to use WhatsApp.
        <br />
        <br /> Sending WhatsApp messages with low relevancy will{' '}
        <b>permanently and irrevocably block</b> the {organizationName} WhatsApp
        number.
        <br />
        <br /> To avoid this: <br />
        <ul style={{ paddingLeft: '18px' }}>
          <li>Only contact engaged, opted-in candidates</li>
          <li>Personalise messages using variables to increase engagement</li>
          <li>Avoid bulk sending</li>
          <li>Use Popp’s opt-out messaging</li>
          <li>
            Monitor message frequency and volume from your campaign dashboard
          </li>
          <li>
            Adhere to WhatsApp's{' '}
            <Link
              href="https://www.whatsapp.com/legal/messaging-guidelines"
              target="_blank"
            >
              messaging guidelines
            </Link>
          </li>
          <li>Maintain a professional and respectful tone</li>
        </ul>
        If you’re not sure whether to use WhatsApp, contact your account
        administrator first.
      </Typography>
      <Stack direction="row">
        <Button variant="primary" onClick={() => closeDrawer()}>
          OK
        </Button>
      </Stack>
    </Stack>
  );
};
